import '@mantine/core/styles.css';
import { MantineProvider } from '@mantine/core';
import { SuperTokensWrapper } from 'supertokens-auth-react';
import '@mantine/dropzone/styles.css';
import { AllRoutes } from './Router';
import { theme } from './theme';
import '@google/model-viewer';
import '@mantine/notifications/styles.css';
import './i18n/i18n';
/* Your App */

export default function App() {
  return (
    <SuperTokensWrapper>
      <MantineProvider theme={theme}>
        <AllRoutes />
      </MantineProvider>
    </SuperTokensWrapper>
  );
}
